import baseApi, {provideTag} from './baseApi'
import {convertToUrlParams} from 'utils'

const emailBroadcastsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getEmailBroadcasts: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `emailBroadcasts${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('EmailBroadcast', result),
        }),
        getEmailRecipientCandidates: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `emailBroadcasts/recipients${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
        }),
        previewEmailBroadcast: build.mutation({
            query: (data) => ({
                url: 'emailBroadcasts/preview',
                method: 'POST',
                body: data,
            }),
            transformResponse: (res) => res,
        }),
        sendEmailBroadcast: build.mutation({
            query: (data) => ({
                url: 'emailBroadcasts',
                method: 'POST',
                body: data,
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['EmailBroadcast'],
        }),
    }),
    overrideExisting: false,
})

export default emailBroadcastsApi

export const {
    useGetEmailBroadcastsQuery,
    useGetEmailRecipientCandidatesQuery,
    useLazyGetEmailRecipientCandidatesQuery,
    usePreviewEmailBroadcastMutation,
    useSendEmailBroadcastMutation,
} = emailBroadcastsApi
